// Global so scrub() replaces every occurrence in a string, not just the
// first — a single breadcrumb message can legitimately mention two share
// URLs. Fine to reuse a global regex with .replace() (it resets lastIndex on
// each call); do NOT reuse these with .test() or .exec(), which would carry
// state between calls.
const SHARE_PATH = /\/s\/[^/?#]+/g;
const REDACTED = '/s/[token]';
const SHARE_API_PATH = /\/api\/shares\/[^/?#]+/g;
const REDACTED_SHARE_API = '/api/shares/[token]';

const scrub = (value) =>
  value.replace(SHARE_PATH, REDACTED).replace(SHARE_API_PATH, REDACTED_SHARE_API);

/**
 * Strip the share token from anywhere Sentry would otherwise record a URL.
 *
 * A share token is the credential and it never expires, so it must not reach
 * the error tracker: not in a pageload transaction's request URL, not in a
 * breadcrumb recording a fetch to /api/shares/<token>, not in a session
 * replay's transaction name, and — easy to miss — not in a navigation
 * breadcrumb either. Sentry's default breadcrumbs integration records browser
 * navigation as `{ category: 'navigation', data: { from, to } }`, pathname
 * strings rather than `data.url`, so simply visiting /s/<token> (it lands in
 * `to`) or navigating away from it (it lands in `from`) is itself a leak path
 * if those fields aren't scrubbed too. Used by App.js as Sentry.init's
 * beforeSend and beforeSendTransaction.
 */
export function redactShareToken(event) {
  if (event.request && typeof event.request.url === 'string') {
    event.request.url = scrub(event.request.url);
  }
  if (Array.isArray(event.breadcrumbs)) {
    event.breadcrumbs.forEach((b) => {
      if (b && b.data) {
        ['url', 'from', 'to'].forEach((k) => {
          if (typeof b.data[k] === 'string') b.data[k] = scrub(b.data[k]);
        });
      }
      if (b && typeof b.message === 'string') {
        b.message = scrub(b.message);
      }
    });
  }
  if (event.transaction && typeof event.transaction === 'string') {
    event.transaction = scrub(event.transaction);
  }
  return event;
}
